<template>
  <div>
    <el-row :gutter="15" class="mt-4">
      <el-col :span="12">
        <h4>Step Ingredients</h4>
      </el-col>
      <el-col :span="12">
        <recipe-item-ingredient-create :stepId="stepId" @create="getIngredients"/>
      </el-col>
    </el-row>
    <div v-if="legacyIngredients.length" style="margin-bottom: 2rem;">
      <h5>Legacy Ingredients</h5>
      <el-table :data="legacyIngredients" style="width: 100%" row-class-name="warning-row">
        <el-table-column label="Amount">
          <template slot-scope="props">
            {{ props.row.amount }} {{ props.row.unit }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="Ingredient">
          <template slot-scope="props">
            <router-link :to="{ name: 'ingredients-id', params: { id: props.row.ingredient.id } }">{{ props.row.ingredient.title }}</router-link>
          </template>
        </el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="props">
            <recipe-item-ingredient-migrate :ingredientId="props.row.id" :stepId="stepId" @update="getIngredients"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-table :data="ingredients" style="width: 100%" empty-text="No recipe ingredients were found." v-loading="loading">
      <el-table-column label="Amount">
        <template slot-scope="props">
          {{ props.row.amount }} {{ props.row.unit }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="Ingredient">
        <template slot-scope="props">
          <router-link :to="{ name: 'ingredients-id', params: { id: props.row.ingredient.id } }">{{ props.row.ingredient.title }}</router-link>
        </template>
      </el-table-column>
      <el-table-column label="Operations">
        <template slot-scope="props">
          <recipe-item-ingredient-edit :ingredient="props.row" :stepId="stepId" @update="getIngredients"/>
          <recipe-item-ingredient-delete :id="props.row.id" @delete="getIngredients"/>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import RecipeItemIngredientCreate from '@/components/Recipe/Item/RecipeItemIngredientCreate'
import RecipeItemIngredientEdit from '@/components/Recipe/Item/RecipeItemIngredientEdit'
import RecipeItemIngredientDelete from '@/components/Recipe/Item/RecipeItemIngredientDelete'
import RecipeItemIngredientMigrate from '@/components/Recipe/Item/RecipeItemIngredientMigrate'

export default {
  components: {
    RecipeItemIngredientCreate,
    RecipeItemIngredientEdit,
    RecipeItemIngredientDelete,
    RecipeItemIngredientMigrate,
  },

  props: {
    recipeId: String,
    stepId: String,
    recipeIngredients: Array,
    legacyIngredients: Array,
  },

  data() {
    return {
      loading: false,
      ingredients: this.recipeIngredients,
    }
  },

  methods: {
    async getIngredients() {
      this.loading = true
      this.ingredients = []

      try {
        var { data } = await this.$http.get(`/recipes/${ this.recipeId }/steps/${ this.stepId }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.ingredients = data.ingredients
    },
  },
}
</script>

<style>
.el-table .warning-row {
  background: #fff9ee;
}
</style>
